import React, { useEffect, useRef } from 'react';
import Layout from '../Layout/Layout.jsx';
import PageTitle from '../Common/PageTitle.jsx';
import styles from '../Common/Common.module.css';
import instructionStyles from './InstructionStep.module.css';

const VIDEO_URL = 'https://storage.googleapis.com/foh-video-arc/Video%20Instructions.mp4';

const InstructionStep = ({ onContinue, onViewMyVideos }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Autoplay muted first (browsers require muted for autoplay), then unmute
    video.muted = true;
    video.play().then(() => {
      video.muted = false;
    }).catch(() => {
      // If autoplay fails even muted, user will need to click play manually
    });
  }, []);

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.card}>
          <PageTitle
            title="Video Instructions"
            subtitle="Please watch this short video before recording your testimony."
          />

          <div className={instructionStyles.content}>
            <div className={instructionStyles['video-wrapper']}>
              <video
                ref={videoRef}
                className={instructionStyles.video}
                controls
                playsInline
              >
                <source src={VIDEO_URL} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className={instructionStyles['bottom-button']}>
            <button
              className={styles.button}
              onClick={onContinue}
            >
              Continue to Recording
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
            {onViewMyVideos && (
              <button
                className={`${styles.button} ${styles['button-secondary']}`}
                onClick={onViewMyVideos}
                style={{ marginTop: '12px' }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
                View My Submissions
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InstructionStep;
